<template>
  <base-page>
    <zy-search-bar v-model="formData.keyword" @onConfirm="onConfirm"/>

    <div class="cates">
      <div></div>
    </div>

    <a-form :label-col="{ span: 2 }" class="filters" labelAlign="left">
      <a-form-item v-if="platforms" label="平台">
        <div class="cates">
          <div v-for="(platform, idx) in platforms" :key="'platform_' + idx" class="cate-item"
               :class="idx === platformIndex ? 'cate-selected' : 'cate-normal'" @click="handlePlatform(idx)">
            {{ platform.name }}
          </div>
        </div>
      </a-form-item>
      <a-form-item v-if="platforms && platformIndex < platforms.length && platforms[platformIndex].cate" label="活动">
        <div class="cates">
          <div v-for="(activity, idx) in platforms[platformIndex].cate" :key="'activity_' + idx" class="cate-item"
               :class="idx === activityIndex ? 'cate-selected' : 'cate-normal'" @click="handleActivity(idx)">
            {{ activity.name }}
          </div>
        </div>
      </a-form-item>
      <a-form-item v-if="filter && filter.cate && filter.cate.length > 0" label="分类">
        <div class="cates">
          <div v-for="(cate, idx) in filter.cate" :key="'cate_' + idx" class="cate-item"
               :class="idx === cateIndex ? 'cate-selected' : 'cate-normal'" @click="handleCate(idx)">
            {{ cate.name }}
          </div>
        </div>
      </a-form-item>
      <a-form-item v-if="filter" label="筛选">
        <div class="cates">
          <div v-if="filter.is_show_commission_rate === '1'" class="fil">
            <span class="prefix">佣金比例≥</span>
            <a-input v-model="formData.start_commission_rate"></a-input>
            <span class="prefix">%</span>
          </div>
          <div v-if="filter.is_show_commission === '1'" class="fil">
            <span class="prefix">返佣金额≥</span>
            <a-input v-model="formData.start_commission_rate"></a-input>
            <span class="prefix"></span>
          </div>
          <div class="fil">
            <div>
              <span class="prefix">价格区间</span>
              <a-input v-model="formData.start_price"></a-input>
              <span class="prefix">-</span>
              <a-input v-model="formData.end_price"></a-input>
            </div>

<!--            <div style="margin-left: 20px;">-->
<!--              <span class="prefix">佣金范围</span>-->
<!--              <a-input v-model="formData.start_price"></a-input>-->
<!--              <span class="prefix">-</span>-->
<!--              <a-input v-model="formData.end_price"></a-input>-->
<!--            </div>-->

<!--            <div style="margin-left: 20px;">-->
<!--              <span class="prefix">销量</span>-->
<!--              <a-input v-model="formData.start_price"></a-input>-->
<!--              <span class="prefix">-</span>-->
<!--              <a-input v-model="formData.end_price"></a-input>-->
<!--            </div>-->
          </div>
          <div class="cate-item cate-selected" @click="_searchGoods">筛选</div>
        </div>
      </a-form-item>

      <a-form-item v-if="filter && filter.sort">
        <a-radio-group v-model="sortKey">
          <a-radio-button v-for="(sort, idx) in filter.sort" :key="'sort_' + idx" :value="sort.key" >
            {{ sort.name }}
          </a-radio-button>
        </a-radio-group>
      </a-form-item>
    </a-form>


    <template v-if="isLoad">
      <a-empty v-if="goodsList.goods.length === 0" style="margin: 80px;"></a-empty>
      <goods-list v-else :goods-list="goodsList.goods"/>
      <div style="text-align: center;margin-top: 20px;">
        <a-pagination v-if="goodsList.total > 0"
            v-model="p"
            show-size-changer
            :total="goodsList.total"
            :page-size.sync="size"
            @showSizeChange="_searchGoods"
            @change="_searchGoods"
        />
        <div v-else class="pagination">
          <a-button :disabled="p <= 1" @click="handlePre">上一页</a-button>
          <div style="margin-left: 10px;margin-right: 10px;">第{{p}}页</div>
          <a-button @click="handleNext" :disabled="goodsList.goods.length === 0">下一页</a-button>

        </div>
      </div>
    </template>
    <a-spin v-else style="text-align: center;width: 100%;margin: 80px 0px;"/>

  </base-page>
</template>

<script>
import BasePage from "@/components/base-page/index.vue";
import ZySearchBar from "@/components/zy-search-bar/index.vue";
import {fetchTypes, fetchCates, searchGoods} from "@/api/search-page"
import GoodsList from '@/components/zy-goods-list/goods-list.vue'

export default {
  name: "index",
  components: {
    BasePage,
    ZySearchBar,
    GoodsList
  },
  data() {
    return {
      platforms: [],
      filter: undefined,
      platformIndex: 0,
      activityIndex: 0,
      cateIndex: 0,
      sortKey: '',
      p: 1,
      size: 20,
      formData: {
        "keyword":"",//关键词
        "type": "",//活动类型
        "cate_id":"",//分类id
        "sort":"",//排序
        "start_sales":"",//销量开始区间
        "start_commission_rate":"",//佣金比例开始区间
        "start_price":"",//价格开始区间
        "end_price":""//价格结束区间
      },
      isLoad: false,
      goodsList: undefined,
    }
  },
  computed: {},
  mounted() {
    const { keyword } = this.$route.query
    this.formData.keyword = keyword

    this._fetchTypes()
  },
  watch: {
    sortKey(nVal, oVla) {
      console.log(nVal, oVla)
      this._searchGoods()
    }
  },
  methods: {
    _fetchTypes() {
      fetchTypes().then(res => {
        this.platforms = res
        this.platformIndex = 0
        this.activityIndex = 0
        this._fetchCates()
      })
    },
    _fetchCates() {
      let params = {}
      if (this.platformIndex < this.platforms.length) {
        const platform = this.platforms[this.platformIndex]
        if (this.activityIndex < platform.cate.length) {
          params['type'] = platform.cate[this.activityIndex].type
        }
      }
      fetchCates(params).then(res => {
        this.filter = res
        if (this.filter.sort && this.filter.sort.length > 0) {
          this.sortKey = this.filter.sort[0].key
        }
        this._searchGoods()
      })
    },
    _searchGoods() {
      let params = JSON.parse(JSON.stringify(this.formData))
      params['p'] = `${this.p}`
      params['size'] = `${this.size}`
      if (this.platformIndex < this.platforms.length) {
        const platform = this.platforms[this.platformIndex]
        if (this.activityIndex < platform.cate.length) {
          params['type'] = platform.cate[this.activityIndex].type
        }
      }
      if (this.cateIndex < this.filter.cate.length) {
        params['cate_id'] = this.filter.cate[this.cateIndex].id
      }
      if (this.sortKey ) {
        params['sort'] = this.sortKey
      }
      searchGoods(params).then(res => {
        this.isLoad = true
        console.log(res)
        this.goodsList = res
      })
    },
    handlePlatform(idx) {
      this.platformIndex = idx
      this.activityIndex = 0
      this._fetchCates()
      // this._searchGoods()
    },
    handleActivity(idx) {
      this.activityIndex = idx
      this._searchGoods()
    },
    handleCate(idx) {
      this.cateIndex = idx
      this._searchGoods()
    },
    onConfirm() {
      this.p = 1
      this._searchGoods()
    },
    handlePre() {
      this.p --
      this._searchGoods()
    },
    handleNext() {
      this.p ++;
      this._searchGoods()
    }
  }
}
</script>

<style scoped lang="scss">
.filters {
  margin-top: 36px;
}

:deep .ant-form-item-label {
  label {
    font-size: 14px;
    color: #8F8F8F;

  }

  label::after {
    content: '';

  }
}

.cates {
  display: flex;
  flex-wrap: wrap;
  align-items: center;

  .cate-item {
    min-width: 80px;
    height: 28px;
    border-radius: 5px;
    font-size: 14px;
    font-weight: 500;
    padding-left: 8px;
    padding-right: 8px;
    line-height: 28px;
    margin: 4px 12px;
    cursor: pointer;
    text-align: center;
    color: #333333;
    background: #EEE4FF;
  }

  .cate-normal {
    color: #333333;
    background: #EEE4FF;
  }

  .cate-selected {
    color: #FFFFFF;
    background: #8D40FF;
  }

  .fil {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    padding: 4px 12px;
    margin-right: 8px;

    .prefix {
      flex-shrink: 0;
      font-size: 14px;
      color: #333333;
      line-height: 20px
    }
    input {
      margin-left: 8px;
      margin-right: 8px;
      width: 58px;
    }
  }
  .fil:hover {
    background: #FFFFFF;
    box-shadow: 0px 0px 9px 0px rgba(208,208,208,0.46);
    border-radius: 4px;
  }
}

.ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {
  z-index: 1;
  border-color: transparent;
  background: linear-gradient(180deg, #8035FF 0%, #BE18FF 100%);
  font-size: 14px;
  color: #FFFFFF;
}

.ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled):hover {
  color: #FFFFFF;
}

.ant-radio-button-wrapper:hover {
  color: #8035FF;
}

.pagination {
  display: flex;
  align-items: center;
  justify-content: center;
}

</style>
